<script>
export default {
  inserted: function (el) {
    let links = el.querySelectorAll(".scroll-links");

    let setOnClick = (element) => {
      if (element.dataset.scrollTo == "#RECONN-DECK-RANGE") {
        window.scrollTo({ top: 1000, behavior: "smooth" });
      } else {
        let target = document.querySelector(element.dataset.scrollTo);
        let offset = document.getElementsByTagName("header")[0].offsetHeight;
        window.scrollTo({ top: target.offsetTop - offset, behavior: "smooth" });
      }
    };

    links.forEach((element) => {
      element.onclick = (event) => {
        event.preventDefault();
        setOnClick(element);
      };
    });
  },
};
</script>
